
import { useFadeIn } from '../../../hooks/useFadeIn';

export default function Suitability() {
  const heading = useFadeIn({ direction: 'up' });
  const body = useFadeIn({ direction: 'up', delay: 200 });

  return (
    <section className="py-32 md:py-40 px-6 bg-gray-50">
      <div className="max-w-3xl mx-auto space-y-12 text-center">
        <div ref={heading.ref} style={heading.style}>
          <h2 className="text-2xl md:text-3xl font-normal text-gray-900 leading-relaxed tracking-wide font-serif">
            マウスピース矯正が、<br />
            適さない場合もあります。
          </h2>
        </div>
        
        <div ref={body.ref} style={body.style} className="space-y-8 text-gray-700 text-base md:text-lg font-light leading-loose">
          <p>
            あなたの歯並びが、<br />
            マウスピース矯正が可能かどうかも丁寧にお伝えします。
          </p>
          <p className="text-sm md:text-base">
            必要に応じて、<br />
            ワイヤー矯正など他の選択肢をご提案することもあります。
          </p>
        </div>
      </div>
    </section>
  );
}
